"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _reactSAlert = require('react-s-alert');

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

var _LocalStorageProxy = require('ibonus/LocalStorageProxy');

var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);

var _wish_list = require('redux/actions/wish_list');

var _modal_type = require('redux/actions/modal_type');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    ProductWishIcon: {
        displayName: 'ProductWishIcon'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/WishList/ProductWishIcon/ProductWishIcon.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var ProductWishIcon = _wrapComponent('ProductWishIcon')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        wishProducts: state.wishList.wishProducts,
        user: state.auth.user,
        lang: state.lang
    };
}, { addToWishList: _wish_list.addToWishList, delFromWishList: _wish_list.delFromWishList, showModifierModal: _modal_type.showModifierModal, setWishList: _wish_list.setWishList }), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(ProductWishIcon, _Component);

    function ProductWishIcon(props) {
        (0, _classCallCheck3.default)(this, ProductWishIcon);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ProductWishIcon.__proto__ || (0, _getPrototypeOf2.default)(ProductWishIcon)).call(this, props));

        _this.handleAddToWish = function (e) {
            e.preventDefault();
            var _this$props = _this.props,
                user = _this$props.user,
                product = _this$props.product;

            if (_this.props.product.modifier !== undefined && _this.props.product.modifier !== null && _this.props.product.modifier.length !== 0) {
                var modNames = [];
                if (_this.props.product.modifier[0] !== undefined) {
                    modNames.push(_this.props.product.modifier[0].name);
                }
                if (_this.props.product.modifier[1] !== undefined) {
                    modNames.push(_this.props.product.modifier[1].name);
                }
                if (_this.props.product.modifier[2] !== undefined) {
                    modNames.push(_this.props.product.modifier[2].name);
                }
                var choose = _this.props.lang['store.wish_list.choose'];
                // if (this.props.isCartProduct && this.props.product.modifier_option_id === undefined) {
                //     Alert.info('Необходимо выбрать ' + modNames.join(', '), {
                //         position: 'top-right',
                //         effect: 'slide',
                //         timeout: 3000
                //     });
                // }
                // if (this.props.isCartProduct !== true) {
                _this.props.showModifierModal(_this.props.product, choose + ' ' + modNames.join(', '));
                // }
                if (_this.props.isModal === true || _this.props.isCartProduct && _this.props.product.modifier_option_id !== undefined) {
                    _this.props.addToWishList(product, user ? user.id : null);
                    setTimeout(_this.props.setWishList(_LocalStorageProxy2.default.getItem('wishlist.common')), 50000);
                }
            } else {
                _this.props.addToWishList(product, user ? user.id : null);
                setTimeout(_this.props.setWishList(_LocalStorageProxy2.default.getItem('wishlist.common')), 50000);
            }
        };

        _this.handleDelFromWish = function (e) {
            e.preventDefault();
            var _this$props2 = _this.props,
                user = _this$props2.user,
                product = _this$props2.product;

            if (_this.props.product.modifier !== undefined && _this.props.product.modifier !== null && _this.props.product.modifier.length !== 0) {
                var modNames = [];
                if (_this.props.product.modifier[0] !== undefined) {
                    modNames.push(_this.props.product.modifier[0].name);
                }
                if (_this.props.product.modifier[1] !== undefined) {
                    modNames.push(_this.props.product.modifier[1].name);
                }
                if (_this.props.product.modifier[2] !== undefined) {
                    modNames.push(_this.props.product.modifier[2].name);
                }
                var choose = _this.props.lang['store.wish_list.choose'];

                _this.props.showModifierModal(_this.props.product, choose + ' ' + modNames.join(', '));

                if (_this.props.isModal === true || _this.props.isCartProduct && _this.props.product.modifier_option_id !== undefined) {
                    _this.props.delFromWishList(product, user ? user.id : null);
                    setTimeout(_this.props.setWishList(_LocalStorageProxy2.default.getItem('wishlist.common')), 50000);
                }
            } else {
                _this.props.delFromWishList(product, user ? user.id : null);
                setTimeout(_this.props.setWishList(_LocalStorageProxy2.default.getItem('wishlist.common')), 50000);
            }
        };

        _this.inWishList = function () {
            var _this$props3 = _this.props,
                wishProducts = _this$props3.wishProducts,
                product = _this$props3.product;

            if (wishProducts === null) {
                return false;
            }
            for (var i = 0; i < wishProducts.length; i++) {
                if (product.id === wishProducts[i].id && wishProducts[i].modifier_option_id === product.modifier_option_id) return true;
            }
            return false;
        };

        return _this;
    }

    (0, _createClass3.default)(ProductWishIcon, [{
        key: 'render',
        value: function render() {
            var inWishList = this.inWishList();
            var _props = this.props,
                inCard = _props.inCard,
                lang = _props.lang;

            return _react3.default.createElement(
                'div',
                { className: 'buttons-holder' },
                inCard ? inWishList ? _react3.default.createElement('a', { onClick: this.handleDelFromWish, className: 'btn-add-to-wishlist active_wish', href: '#' }) : _react3.default.createElement('a', { onClick: this.handleAddToWish, className: 'btn-add-to-wishlist', href: '#' }) : inWishList ? _react3.default.createElement(
                    'a',
                    { onClick: this.handleDelFromWish, className: 'btn-add-to-wishlist active_wish text-theme-color', href: '#' },
                    lang['store.wish_list.item_in_list']
                ) : _react3.default.createElement(
                    'a',
                    { onClick: this.handleAddToWish, className: 'btn-add-to-wishlist text-theme-color', href: '#' },
                    lang['store.wish_list.add_to_wish_list']
                )
            );
        }

        /**
         * Проверяет находится ли товар в избранном
         */

    }]);
    return ProductWishIcon;
}(_react2.Component), _class2.propTypes = {
    //product: PropTypes.obj.isRequired
}, _temp)) || _class));

exports.default = ProductWishIcon;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/WishList/ProductWishIcon/ProductWishIcon.jsx
// module id = 1791
// module chunks = 0